<template>
  <div class="award">
    <Modal
      v-model="modal"
      :title="$t('title.w64')"
      :loading="loading"
      :footer-hide="true"
      :mask-closable= "false"
    >
      <Form
        ref="form"
        class="awardform"
        :model="form"
        :rules="formRules"
        label-position="top"
      >
        <FormItem :label="$t('label.w220')" prop="amount">
          <Input v-model="form.amount" @on-blur="blurChage('amount')"/>
          <div class="maxamount">
            <span class="s1">{{$t('msg.m132')}}</span>
            <span class="s2">{{maxmoney|money}}元</span>
          </div>
          <div class="allchange" @click="all">{{$t('btn.b85')}}</div>
        </FormItem>
        <FormItem :label="$t('label.w21')" prop='transactionPassword'  >
          <Input v-model="form.transactionPassword"  type="password" autocomplete="off"/>
        </FormItem>
        <Divider dashed />
        <FormItem class="btn" :style="{marginBottom:0}">
          <Button :loading="loading" @click="submit">{{$t('btn.b5')}}</Button>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import formRule from "@/libs/formRule";
export default {
  props: ["maxmoney"],
  data() {
    return {
      modal: false,
      loading: false,
      form: {
        amount: "",
        transactionPassword: ""
      },
      formRules: {
        amount: [
          { required: true, message: this.$t("msg.m52"), trigger: "submit" },
          {
            validator: (rule, value, callback) => {
              if (/^\d+(\.\d{1,2})?$/.test(value.toString())) {
                callback();
              } else {
                callback(new Error(this.$t("msg.m52")));
              }
            },
            trigger: "submit"
          }
        ],
        transactionPassword: formRule.pwdUse
      }
    };
  },
  methods: {
    all(){
        this.form.amount = this.maxmoney.toString()
    },
    blurChage(type) {
      if (type == "amount") {
        if (this.form.amount  > this.maxmoney) {
          this.form.amount = this.maxmoney.toString();
        }else{
          this.form.amount = Number(this.form.amount).toString()
        }
      }
    },
    async submit() {
        let valid= await this.$refs.form.validate();
        if(!valid) return;
        this.loading= true
        this.$axios.post('/Member/RZJFund/AwardAmountToManagementFeeAmount',{
            ...this.form
        })
        .then(res => {
         this.loading = false
         if(res.err) return res.throw();
         this.form.amount=''
         this.form.transactionPassword=''
         this.$store.dispatch("user/getUser",'all');
         this.modal = false
        })
       
    }
  }
};
</script>

<style lang="less" scoped>
/deep/.ivu-modal-header-inner{
    font-size: 16px !important;
}
/deep/.ivu-input-wrapper {
  width: 260px;
}
/deep/.ivu-form-item-label {
  color: #333;
  font-weight: bold;
  margin-bottom: 5px;
  font-size: 14px;
}
/deep/.ivu-form-item {
  margin-bottom: 20px;
}
/deep/.ivu-form-item-content {
  .maxamount {
    font-size: 14px;
    position: absolute;
    left: 290px;
    top: -8px;
    .s1{color: #333;}
    .s2{color: #F64750; margin-left: 5px;}
  }
  .allchange {
    font-size: 14px;
    position: absolute;
    left: 290px;
    top: 15px;
    cursor: pointer;
    color: rgba(74, 112, 242, 1);
  }
}
/deep/.ivu-btn {
  background: rgba(74, 112, 242, 1);
  width: 140px;
  height: 40px;
  border-radius: 20px;
  color: #fff;
  font-size: 18px;
  font-weight: 500;
}
.btn {
  display: flex;
  justify-content: flex-end;
}
</style>
